<template>
  <div class="page">
    <div class="partner">
      <div class="partner-top">
        <div class="partnerTitle">{{ props.data.titleCn }}</div>
        <div class="partnerEn">{{ props.data.titleEn }}</div>
      </div>
      <div class="partner-bottom">
        <div class="bottom-list">
          <div class="list-item" v-for="(item, index) in props.data.list" :key="index">
            <div class="item-title">
              {{ item.title }}<div class="item-desc">（排序不分先后）</div>
            </div>
            <div class="item-photos">
              <div v-for="(child, indexa) in item.photos" :key="indexa" class="photo-item">
                <img :src="child" alt="" class="photo-img" />
              </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})
onMounted(() => {
  console.log(props.data.list[5],2231)
})
</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  justify-content: center;
  .partner {
    width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 116px;
    .partner-top{
      display: flex;
      flex-direction: column;
      align-items: center;
      .partnerTitle{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 36px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .partnerEn{
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 16px;
      }
    }
    .partner-bottom{
      width: 100%;
      margin-top: 32px;
      .bottom-list{
        width: 100%;
        display: flex;
        flex-direction: column;
        .list-item{
          width: 100%;
          display: flex;
          flex-direction: column;
          margin-top: 48px;
          .item-title{
            display: flex;
            align-items: center;
            color: rgba(44, 44, 44, 1);
            font-family: Microsoft YaHei;
            font-size: 24px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: 0px;
            margin-bottom: 24px;
            .item-desc{
              color: rgba(44, 44, 44, 1);
              font-family: Microsoft YaHei;
              font-size: 16px;
              font-weight: 400;
              line-height: 16px;
              letter-spacing: 0px;
              margin-left: 6px;
            }
          }
          .item-photos{
            display: grid;
            grid-template-columns: repeat(8, 1fr);
            gap: 12px;
            .photo-item{
              width: 100%;
              height: 66px;
              background: rgba(255, 255, 255, 1);
              display: flex;
              align-items: center;
              justify-content: center;
              .photo-img{
                max-height: 40px;
                max-width: 80%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
